module.exports = __webpack_public_path__ + "img/Combien.73a67d2d.png";